<div [class.writeable]="!isReadOnly">
  @for (i of [ 0, 1, 2, 3, 4 ]; track i) {
    <span>
      @if (rating > i) {
        <i class="fa-sharp fa-solid fa-star" (click)="setRating(i + 1)"></i>
      }
      @if (rating <= i) {
        <i class="fa-sharp fa-regular fa-star" (click)="setRating(i + 1)"></i>
      }
    </span>
  }
</div>